"use client";
import { LogosGridOptionsType } from "@/types/ModuleOptionsType";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { fetchLogos, LogosCardElementType } from "./fetchLogos";
import { LogoCard } from "../../components/LogoCard/LogoCard";
import buttonStyles from "../../components/Button/Button.module.scss";
import { mockLogo } from "@/ui/mock-data";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";
import { LogosGridModuleType } from "./LogosGrid.server";

interface LogosGridProps {
  data: LogosGridModuleType;
  logosGridOptions: {
    box: LogosGridOptionsType["box"];
    grayscale: LogosGridOptionsType["grayscale"];
    grid_options: {
      grid_navigation: LogosGridOptionsType["grid_options"]["grid_navigation"];
    };
    box_color: LogosGridOptionsType["box_color"];
  };
  itemWidth: Record<Breakpoint, string>;
  initialPosts: LogosCardElementType[];
  initialTotalPosts: number;
}

const LogosGridModuleClient = ({
  data,
  logosGridOptions,
  itemWidth,
  initialPosts,
  initialTotalPosts,
}: LogosGridProps) => {
  const { posts_per_page } = data.layout;
  const {
    box: { show_border_radius, show_box_shadow, show_card_box },
    grayscale,
    grid_options: { grid_navigation },
    box_color,
  } = logosGridOptions ?? {};

  const { locale } = useGlobalContext();

  return (
    <Grid
      // key={refreshKey}
      initialItems={initialPosts}
      initialTotalPosts={initialTotalPosts}
      postsPerPage={posts_per_page}
      fetchItems={({ page, postsPerPage, offset }) => {
        return fetchLogos({
          page,
          postsPerPage,
          offset,
          module: data,
          locale,
        });
      }}
      renderLoading
    >
      {(gridLogos, loading) => {
        return (
          <>
            <GridContent justifyContent="center" gap="2rem">
              {gridLogos.map((logo, key) => {
                return (
                  <GridItem itemWidth={itemWidth} key={key}>
                    <LogoCard
                      skeleton={loading}
                      key={key}
                      element={
                        loading ? mockLogo : (logo as LogosCardElementType)
                      }
                      show_border_radius={show_border_radius}
                      show_box_shadow={show_box_shadow}
                      showBox={show_card_box}
                      boxBackgroundColor={box_color || ""}
                      grayscale={grayscale}
                    />
                  </GridItem>
                );
              })}
              {/* jscpd:ignore-start */}
            </GridContent>
            <GridLoadMore
              grid_navigation={grid_navigation}
              buttonStyles={buttonStyles}
              iconPosition="left"
            />
          </>
        );
      }}
    </Grid>
  );
  /* jscpd:ignore-end */
};

export default LogosGridModuleClient;
